import * as React from 'react';
import * as cx from 'classnames';
import { observer } from 'mobx-react';

import './code-cell.css';
import CodeCellStore from 'src/stores/CodeCellStore';
import GreyCatEditor from '../GreyCatEditor';
import PlaygroundStore from 'src/stores/PlaygroundStore';
import Result from '../Result';

export interface CodeCellProps {
  pgStore: PlaygroundStore;
  store: CodeCellStore;
  className: string;
}

@observer
export default class CodeCell extends React.Component<CodeCellProps> {

  constructor(props: CodeCellProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onExecuteClick = this.onExecuteClick.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
  }

  onClick(e: React.MouseEvent) {
    this.props.pgStore.setSelected(this.props.store, true);
  }

  onExecuteClick(e: React.MouseEvent) {
    this.props.pgStore.setSelected(this.props.store, true);
    this.props.store.execute();
  }

  onEditorChange(newValue: string) {
    this.props.store.source = newValue;
  }

  render() {
    const { store, className } = this.props;
    const { selected, source, data, executed, error } = store;

    return (
      <div
        className={cx('code-cell', className, { selected: selected })}
        onClick={this.onClick}
      >
        <div className="status">
          <span>
            <i className="oi oi-media-play execute" onClick={this.onExecuteClick} />
          </span>
          <span>
            <span>[</span>
            {!executed && (<span>&nbsp;</span>)}
            {executed && !error && (<span style={{ color: 'green' }}>✔</span>)}
            {executed && error && (<span style={{ color: 'red' }}>✘</span>)}
            <span>]</span>
          </span>
        </div>
        <div style={{ display: 'flex', flexGrow: 1, flexFlow: 'column' }}>
          <GreyCatEditor className="greycat-editor" value={source} onChange={this.onEditorChange} />
          {data && <Result store={store} />}
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </div>
    );
  }
}
